/**
 * Registers all tool components the Analysis Agent can emit. Render once
 * inside an `AssistantRuntimeProvider` so the runtime knows how to render
 * each tool-call part type.
 */
import type { FC } from "react";
import { BackendQuizTool } from "~/components/assistant-v2/BackendQuizTool";
import { CreatePlanTool } from "~/components/assistant-v2/CreatePlanMessage";
import { FrontendQuizTool } from "~/components/assistant-v2/FrontendQuizTool";
import { PipelineConfirmationTool } from "~/components/assistant-v2/PipelineConfirmationMessage";
import {
  ApprovalCardTool,
  OptionListTool,
  ParameterSliderTool,
  PlanTool,
  QuestionFlowTool,
} from "~/components/assistant-v2/tools";

interface AnalysisAgentToolsProps {
  pipelineToolsEnabled?: boolean;
}

export const AnalysisAgentTools: FC<AnalysisAgentToolsProps> = ({ pipelineToolsEnabled }) => (
  <>
    <FrontendQuizTool />
    <BackendQuizTool />
    <CreatePlanTool />
    <ParameterSliderTool />
    <OptionListTool />
    <QuestionFlowTool />
    <PlanTool />
    <ApprovalCardTool />
    {pipelineToolsEnabled && <PipelineConfirmationTool />}
  </>
);
